import React from "react";
import { useLocation } from "react-router-dom";

import AdsSlider from "../components/AdsSlider";
import FeaturedNews from "../components/FeaturedNews";

import "../assets/css/MainLayout.css";
import YouTubeSlider from "../components/YouTubeSlider";

const MainLayout = ({ children }) => {

    const location = useLocation();

    // Check if current page is Home page
    const isHomePage = location.pathname === "/" || location.pathname === "/home" || location.pathname === "/contact";

    return (

        <div className="main-layout container-fluid">

            <div className="row d-flex justify-content-center">
                {/* LEFT SIDEBAR - ONLY HOME PAGE */}
                {isHomePage && (
                    <div className="column-01">
                        <div className="sticky-sidebar">
                            <div className="featured-section">
                                <FeaturedNews type="news" limit={3} />
                            </div>
                            <div className="ads-section">
                                <AdsSlider placement="leftside-hero" />
                            </div>
                        </div>
                    </div>
                )}

                {/* CENTER CONTENT */}
                <div className={isHomePage ? "column-02" : "col-lg-12"}>
                    <div className="main-content">
                        {children}
                    </div>
                </div>

                {/* RIGHT SIDEBAR - ONLY HOME PAGE */}
                {isHomePage && (
                    <div className="column-03">
                        <div className="sticky-sidebar">
                            <AdsSlider placement="rightside-hero" />
                            <YouTubeSlider />
                        </div>
                    </div>
                )}

            </div>

        </div>

    );

};

export default MainLayout;